import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContextMenuItem } from 'redesign';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { hqRoutes } from 'hq/Routes';
import { UseGetDocumentItemActionsProps } from './use-get-document-item-actions.types';
import { DocumentStatus } from '../../../documents-type';

export const useGetDocumentItemActions = ({
  setParams,
  params,
}: UseGetDocumentItemActionsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generatePath = useHqRelativePath();

  const handleOpenDialog = useCallback(
    (documentId: string) => {
      setIsOpen(true);
      setParams({ documentId });
    },
    [setParams]
  );

  const handleCloseDialog = useCallback(() => {
    setIsOpen(false);
    setParams({ documentId: undefined });
  }, [setParams]);

  const handleEditDocument = useCallback(
    (documentId: string) => {
      const editPath = generatePath(
        hqRoutes.EditDocument,
        { documentId },
        {
          ...(params.status && { status: params.status }),
          ...(params.documentType && { documentType: params.documentType }),
          ...(params.name && { name: params.name }),
        }
      );

      navigate(editPath);
    },
    [navigate, generatePath]
  );

  const getRowActions = (documentId: string, status: DocumentStatus) => {
    const actions = [
      <ContextMenuItem key="detail" onClick={() => handleOpenDialog(documentId)}>
        {t('document_check.table.actions.detail', { ns: 'hq-screen-specific' })}
      </ContextMenuItem>,
    ];

    if (status !== 'Signed') {
      actions.push(
        <ContextMenuItem key="edit" onClick={() => handleEditDocument(documentId)}>
          {t('document_check.table.actions.edit', { ns: 'hq-screen-specific' })}
        </ContextMenuItem>
      );
    }

    return actions;
  };

  return {
    getRowActions,
    isOpen,
    handleCloseDialog,
  };
};
